import {ChangeDetectionStrategy, ChangeDetectorRef, Component, inject, input} from '@angular/core';
import {headerCalculatorRatingRow, headerProductRatingRow} from "../../configs/pc-rating-modal-config";
import {CalculateWeeklyRatingParams, ProductCardRatingWeekly} from "../../types/pc-rating-modal.types";
import {PcRatingService} from "../../services/pc-rating.service";
import {MatFormField, MatInput, MatLabel} from "@angular/material/input";
import {FormsModule} from "@angular/forms";
import {MatTooltip} from "@angular/material/tooltip";
import {ScrollSyncDirective} from "../../../../../../../../shared/directives/scroll-sync.directive";

@Component({
  selector: 'app-pc-rating-body',
  standalone: true,
  imports: [
    MatFormField,
    MatInput,
    MatLabel,
    FormsModule,
    MatTooltip,
    ScrollSyncDirective
  ],
  templateUrl: './pc-rating-body.component.html',
  styleUrl: './pc-rating-body.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class PcRatingBodyComponent {
  ratingData = input<Array<ProductCardRatingWeekly>>([]);
  productCardId = input<number | null>(0);
  weeklyCount = input<number>(0);

  private pcRatingService: PcRatingService = inject(PcRatingService);
  private cd: ChangeDetectorRef = inject(ChangeDetectorRef);

  public readonly headerCalculatorRatingRow = headerCalculatorRatingRow;
  public readonly headerProductRatingRow = headerProductRatingRow;

  public get weeklyColumns(): Array<number> {
    return Array(this.weeklyCount()).fill(0).map((_, i) => i);
  }

  public async changeTargetRating(rowData: ProductCardRatingWeekly, index: number): Promise<void> {
    if (rowData.targetRating && (rowData.targetRating > 5 || rowData.targetRating < 0)) { return; }

    const calculateWeeklyRatingParams: CalculateWeeklyRatingParams = {
      targetRating: rowData.targetRating || 0,
      productCardId: this.productCardId() || 0,
      article: rowData.article
    };

    this.ratingData()[index].result = await this.pcRatingService.calculateWeeklyRating(calculateWeeklyRatingParams).catch(() => 0);
    this.cd.detectChanges();
  }

  public getResult(index: number) {
    return this.ratingData().at(index)?.result || 0;
  }
}
